// Utilidades para formateo de moneda en Honduras

export const formatCurrency = (amount: number): string => {
  // Round down to eliminate cents
  const roundedAmount = Math.floor(amount);
  return new Intl.NumberFormat('es-HN', {
    style: 'currency',
    currency: 'HNL',
    currencyDisplay: 'code',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(roundedAmount).replace('HNL', 'L');
};

export const formatNumber = (amount: number): string => {
  // Round down to eliminate cents for currency-related numbers
  const roundedAmount = Math.floor(amount);
  return new Intl.NumberFormat('es-HN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(roundedAmount);
};

export const parseCurrency = (value: string): number => {
  // Remover símbolos de moneda y convertir a número
  const cleaned = value.replace(/[L\s,.]/g, '');
  return parseFloat(cleaned) || 0;
};